import { useEffect } from 'react';

import { GTMEventLogger } from 'utils/analytics';

import { GTMEvents } from 'constants/enums';

const usePageviewEvent = (event: GTMEvents): void => {
  useEffect(() => {
    GTMEventLogger(event);
  }, []);
};

export default usePageviewEvent;
